import React from 'react'
import { Button, ButtonGroup, Card, CardBody } from 'reactstrap'


const ComponentOpciones = ({ value, setValue, productos, productoSeleccionado, setProductoSeleccionado, indexProducto, setIndexProducto }) => {


    return (
        <Card>
            <CardBody>







                <ButtonGroup>


                    {productos.map((producto, index) => {
                        const activo = (productoSeleccionado ? productoSeleccionado.codigo == producto.codigo : false)
                        return (
                            <div>
                                <Button
                                    className={
                                        activo
                                            ? "btn btn-primary "
                                            : "btn btn-primary btn-light"
                                    }
                                    onClick={(() => {
                                        setProductoSeleccionado(producto, index)
                                        setIndexProducto(index)
                                    })}

                                >
                                    {'Opción ' + (index + 1) + ': ' + producto.datosAp.actividad.label}
                                </Button>
                            </div>
                        )
                    })}
                </ButtonGroup>



            </CardBody>
        </Card>
    )

}

export default ComponentOpciones